<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-6" style="display: flex;justify-content: start;align-items: center;">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioEstados" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstadosFiltro" formControlName="estado" [control]="formulario.get('estado')"
          [label]="'Estado *'" [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <div class="form-group col-md-3" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Detalle'" [label]="'Detalle *'"
          [id]="'descripcion'" formControlName="descripcion" [control]="formulario.get('descripcion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbVariables" formControlName="tipoVariable" [control]="formulario.get('tipoVariable')"
          [label]="'Tipo de Variable *'" [id]="'tipoVariable'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <div
          *ngIf="formulario.get('tipoVariable').value != 'INCENTIVO_VEHICULAR'">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbRecursosFiltered" formControlName="tipoRecurso" [control]="formulario.get('tipoRecurso')"
            [label]="'Tipo de Recurso *'" [id]="'tipoRecurso'">
          </app-lfsa-combo-box>
        </div>
      </div>
      <div class="form-group col-12 col-md-4">
        <div
          *ngIf="formulario.get('tipoVariable').value != 'INCENTIVO' && formulario.get('tipoVariable').value != 'INCENTIVO_VEHICULAR'">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbMedidasFiltered" formControlName="tipoMedida" [control]="formulario.get('tipoMedida')"
            [label]="'Tipo de Medida *'" [id]="'tipoMedida'">
          </app-lfsa-combo-box>
        </div>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % Mínimo de Ganancia'"
          [label]="'% Mínimo de Ganancia *'" [id]="'minimo'" formControlName="minimo"
          [control]="formulario.get('minimo')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % Máximo de Ganancia'"
          [label]="'% Máximo de Ganancia *'" [id]="'maximo'" formControlName="maximo"
          [control]="formulario.get('maximo')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstados" formControlName="estado" [control]="formulario.get('estado')" [label]="'Estado *'"
          [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Configuracion Tipos de Variables e Incentivos'"
  [idButton]="'buttonAbrirModal'" [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'idVariable'" formControlName="idVariable"
          [control]="formulario.get('idVariable')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Detalle'" [label]="'Detalle *'"
          [id]="'descripcion'" formControlName="descripcion" [control]="formulario.get('descripcion')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbVariables" formControlName="tipoVariable" [control]="formulario.get('tipoVariable')"
          [label]="'Tipo de Variable *'" [id]="'tipoVariable'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbRecursosFiltered" formControlName="tipoRecurso" [control]="formulario.get('tipoRecurso')"
          [label]="'Tipo de Recurso *'" [id]="'tipoRecurso'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <div *ngIf="formulario.get('tipoVariable').value != 'INCENTIVO'">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
            [comboBox]="cmbMedidasFiltered" formControlName="tipoMedida" [control]="formulario.get('tipoMedida')"
            [label]="'Tipo de Medida *'" [id]="'tipoMedida'">
          </app-lfsa-combo-box>
        </div>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % Mínimo de Ganancia'"
          [label]="'% Mínimo de Ganancia *'" [id]="'minimo'" formControlName="minimo"
          [control]="formulario.get('minimo')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese % Máximo de Ganancia'"
          [label]="'% Máximo de Ganancia *'" [id]="'maximo'" formControlName="maximo"
          [control]="formulario.get('maximo')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
          [comboBox]="cmbEstados" formControlName="estado" [control]="formulario.get('estado')" [label]="'Estado *'"
          [id]="'estado'">
        </app-lfsa-combo-box>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>